module.exports = __webpack_public_path__ + "static/mo07-6af4757ed486f9a692a6c5bf4a429b27.png";